import { render } from "./groupOrderList.vue?vue&type=template&id=4928a36c&scoped=true"
import script from "./groupOrderList.vue?vue&type=script&lang=js"
export * from "./groupOrderList.vue?vue&type=script&lang=js"

import "./groupOrderList.vue?vue&type=style&index=0&id=4928a36c&scoped=true&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4928a36c"]])

export default __exports__